(function () {
  let targetForm = null;

  function init() {
    if (document.getElementById('noikika-size-drawer')) return;

    const drawer = document.createElement('div');
    drawer.id = 'noikika-size-drawer';
    drawer.innerHTML = `
      <div id="noikika-size-drawer-overlay"></div>
      <div id="noikika-size-drawer-panel">
        <div id="noikika-size-drawer-header">
          <span>SELEZIONA LA TAGLIA</span>
          <button id="noikika-size-drawer-close" type="button">✕</button>
        </div>
        <div id="noikika-size-drawer-options"></div>
      </div>
    `;
    document.body.appendChild(drawer);

    const style = document.createElement('style');
    style.textContent = `
      #noikika-size-drawer-overlay {
        display: none; position: fixed; inset: 0;
        background: rgba(0,0,0,0.4); z-index: 9998;
      }
      #noikika-size-drawer-panel {
        display: none; position: fixed; bottom: 0; left: 0; right: 0;
        background: #fff; z-index: 9999; padding: 24px;
        border-radius: 16px 16px 0 0;
        box-shadow: 0 -4px 20px rgba(0,0,0,0.15);
        padding-bottom: 80px;
      }
      #noikika-size-drawer-header {
        display: flex; justify-content: space-between; align-items: center;
        margin-bottom: 20px; font-size: 14px; letter-spacing: 0.1em;
      }
      #noikika-size-drawer-close {
        background: none; border: none; font-size: 18px; cursor: pointer;
      }
      #noikika-size-drawer-options {
        display: flex; flex-wrap: wrap; gap: 10px;
      }
      .noikika-size-btn {
        padding: 12px 20px; border: 1px solid #000; background: #fff;
        cursor: pointer; font-size: 14px; letter-spacing: 0.05em;
        min-width: 60px; text-align: center;
      }
      .noikika-size-btn.selected { background: #000; color: #fff; }
      #noikika-size-drawer-overlay.active { display: block; }
      #noikika-size-drawer-panel.active { display: block; }
    `;
    document.head.appendChild(style);

    document.getElementById('noikika-size-drawer-close').addEventListener('click', closeDrawer);
    document.getElementById('noikika-size-drawer-overlay').addEventListener('click', closeDrawer);

    window.noikikaOpenDrawer = openDrawer;
  }

  function closeDrawer() {
    document.getElementById('noikika-size-drawer-overlay')?.classList.remove('active');
    document.getElementById('noikika-size-drawer-panel')?.classList.remove('active');
    targetForm = null;
  }

  function openDrawer() {
    targetForm = document.querySelector('[data-type="add-to-cart-form"]');
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;

    const optionGroups = variantPicker.querySelectorAll('[data-variant-picker-option-labels]');
    let sizeOption = null;
    optionGroups.forEach(opt => {
      const name = (opt.getAttribute('option-picker-name') || '').toLowerCase();
      if (!['colore', 'color', 'colour'].includes(name)) sizeOption = opt;
    });
    if (!sizeOption) return;

    const container = document.getElementById('noikika-size-drawer-options');
    container.innerHTML = '';
    const pills = sizeOption.querySelectorAll('label.pill');
    if (!pills.length) return;

    pills.forEach(pill => {
      const value = pill.querySelector('.pill__label')?.textContent.trim();
      const forAttr = pill.getAttribute('for');
      const input = document.getElementById(forAttr);
      if (!input) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'noikika-size-btn' + (pill.classList.contains('selected') ? ' selected' : '');
      btn.textContent = value;
      btn.addEventListener('click', function () {
        // Seleziona la variante nel picker
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        closeDrawer();

        setTimeout(() => {
          // Clicca il bottone submit principale (non sticky) del form
          const mainSubmitBtn = document.querySelector('.product-form__btn:not(.product-form__mobile-sticky-button .product-form__btn)');
          if (mainSubmitBtn) {
            mainSubmitBtn.click();
          } else if (targetForm) {
            targetForm.querySelector('[type="submit"]')?.click();
          }
        }, 400);
      });
      container.appendChild(btn);
    });

    document.getElementById('noikika-size-drawer-overlay').classList.add('active');
    document.getElementById('noikika-size-drawer-panel').classList.add('active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
